import React from 'react';
import { Layout } from 'react-theme-bootstrap'
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { apiResource, appUrl, companyName, logoWhite, sessionName } from '../utils';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

AppLayout.defaultProps = {
  titleTop: '',
  hideTop: false
}

export default function AppLayout({
  children, page, title, titleTop, hideTop
}) {
  const { permissions, username, photo_user, isCustomer, full_name } = useSelector(store => store.session);
  const history = useHistory();

  return <Layout
    page={page}
    title={title}
    hideTop={hideTop}
    titleTop={titleTop ? titleTop : title}
    companyName={companyName()}
    brand={logoWhite()}
    openNavDesktop
    permissions={permissions}
    iconsRight={[
      {
        type: 'html', content: <span>{isCustomer ? full_name : username}</span>,
        style: {
          minWidth: 300,
          fontSize: 15,
          justifyContent: 'flex-end',
          paddingRight: 20
        },
        noHover: true,
        hideOnMobile: true
      },
      ...(isCustomer ? [{
        type: 'html',
        content: <div onClick={_ => {
          history.push(appUrl({
            url: '/mis-tickets'
          }))
        }}>
          <i className='fas fa-ticket-alt' style={{
            padding: 20
          }}></i>
        </div>,
      }] : []),
      ...(isCustomer ? [{
        type: 'html',
        content: <div onClick={_ => {
          history.push(appUrl({
            url: '/carrito'
          }))
        }}>
          <i className='fas fa-shopping-cart text-white' style={{
            padding: 20
          }}></i>
        </div>,
      }] : []),
      ...(isCustomer ? [{
        type: 'html',
        content: <div onClick={_ => {
          history.push(appUrl({
            url: '/productos'
          }))
        }} title="Productos">
          <i className='fas fa-box text-white' style={{
            padding: 20
          }}></i>
        </div>,
      }] : []),
      {
        type: 'image',
        content: apiResource({
          url: photo_user
        }),
        dropdown: ({ custom }) => {
          return <Dropdown>
            <Dropdown.Toggle as={custom} />
            <Dropdown.Menu>
              <Dropdown.Item className="d-flex" onClick={_ => {
                localStorage.removeItem(sessionName());
                localStorage.removeItem('session-customer-storage');
                window.location.href = '/login';
              }}>
                <i className="fa fa-arrow-left me-2 align-self-center"></i>
                <span>Salir</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        }
      }
    ]}
    Link={Link}
    linkTo={appUrl}
    linkToBrand={appUrl({
      url: '/'
    })}
  >
    {children}
  </Layout>
}